import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CardBase, * as Card from '@segment/matcha/recipes/Card'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const data = [
  {
    label: `Blog`,
    heading: `Twilio Segment expands Ad-Tech capabilities to maximize advertising reach and impact`,
    description: `Unlock the power of personalized advertising with Twilio Segment, introducing seven new capabilities in advertising, privacy, and AI to help marketers excel in the ever-changing landscape of data-driven marketing.`,
    ctaTitle: `Read the blog`,
    ctaUrl: `https://segment.com/blog/segment-expands-omnichannel-adtech-capabilities/`,
  },
  {
    label: `Recipe`,
    heading: `How to Use Lookalike Audiences and Audience Suppression`,
    description: `In this recipe, you’ll learn how to use Twilio Engage (formerly Segment Personas) to create hyper-specific audiences in advertising platforms like Facebook, Snapchat, and Pinterest to increase advertising efficiency.`,
    ctaTitle: `Use this recipe`,
    ctaUrl: `/recipes/increase-advertising-efficiency-lookalike-audiences-advertising-suppression/`,
  },
  {
    label: `Blog`,
    heading: `Insights from Advertising Week 2023: AdTech and AI lead the future`,
    description: `We share key insights from sponsoring Ad Week, discussing the opportunities in the advertising industry, the role of AI in enhancing creativity and efficiency, and the importance of first-party data in the evolving landscape of ad personalization.`,
    ctaTitle: `Read the blog`,
    ctaUrl: `https://segment.com/blog/insights-from-ad-week-2023/`,
  },
]

const TITLE = `Resources`

const Resources = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{TITLE}</CopyText.Heading>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          overrides={{
            md: 3,
          }}
        >
          {data.map(({ label, heading, description, ctaTitle, ctaUrl }, key) => (
            <CardBase href={getAbsoluteUrl(ctaUrl, pageConfig)} key={key}>
              <Card.Body>
                <Card.Accessories>
                  <Card.AccessoriesRow>
                    <Card.Label>{label}</Card.Label>
                  </Card.AccessoriesRow>
                </Card.Accessories>
                <Card.Copy>
                  <Card.Headline tag="h3">{heading}</Card.Headline>
                  <Card.Description>{description}</Card.Description>
                </Card.Copy>
                <Card.Action alignment="left">
                  <ButtonText iconEnd={ChevronRightIcon}>{ctaTitle}</ButtonText>
                </Card.Action>
              </Card.Body>
            </CardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default Resources
